var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgButton2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2004 4.38375C5.0442 4.22754 4.79093 4.22754 4.63472 4.38375C4.47851 4.53996 4.47851 4.79323 4.63472 4.94944L5.68522 5.99993L4.63473 7.05042C4.47852 7.20663 4.47852 7.45989 4.63473 7.6161C4.79094 7.77231 5.04421 7.77231 5.20042 7.6161L6.2509 6.56562L7.30137 7.61609C7.45758 7.7723 7.71085 7.7723 7.86706 7.61609C8.02327 7.45988 8.02327 7.20662 7.86706 7.05041L6.81659 5.99993L7.86707 4.94945C8.02328 4.79324 8.02328 4.53997 7.86707 4.38376C7.71086 4.22755 7.4576 4.22755 7.30139 4.38376L6.2509 5.43425L5.2004 4.38375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25091 0.266602C3.08448 0.266602 0.517578 2.8335 0.517578 5.99994C0.517578 9.16637 3.08448 11.7333 6.25091 11.7333C9.41735 11.7333 11.9842 9.16637 11.9842 5.99994C11.9842 2.8335 9.41735 0.266602 6.25091 0.266602ZM1.31758 5.99994C1.31758 3.27533 3.52631 1.0666 6.25091 1.0666C8.97552 1.0666 11.1842 3.27533 11.1842 5.99994C11.1842 8.72454 8.97552 10.9333 6.25091 10.9333C3.52631 10.9333 1.31758 8.72454 1.31758 5.99994Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgButton2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Button2.f04dfff2.svg";
export { ForwardRef as ReactComponent };